/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import deepUiLib from './deep-ui-lib'
import icons from './fontawesome'
import i18n from './i18n'
import { getRouter } from './router'
import { initSentry } from './sentry'
import vuetify from './vuetify'
// Types
import type { App } from 'vue'

export function registerPlugins(app: App) {
  app.use(i18n)
  app.use(icons)
  app.use(vuetify)
  app.use(deepUiLib)
}

export function registerRouter(app: App) {
  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  app.use(getRouter())
}

export function registerSentry(app: App) {
  if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
    return initSentry(app, import.meta.env.VITE_SENTRY_DSN, {
      routerInstance: getRouter(),
      debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
      environment: import.meta.env.VITE_ENVIRONMENT,
      release: import.meta.env.VITE_SENTRY_RELEASE,
      tracesSampleRate: parseFloat(
        import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
      ),
      replaysSessionSampleRate: parseFloat(
        import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
      ),
      replaysOnErrorSampleRate: parseFloat(
        import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
      ),
    })
  }
}
